import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {CustomUserService} from '../../services/custom-user.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {environment} from '../../../environments/environment';
import {PRIVACY_POLICY_URL} from '../../constants/app.constants';

@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss']
})
export class MfaComponent implements OnInit {
  @ViewChild('codeInput') codeInput!: any;
  mfaMethod = '';
  submitted = false;
  codeResent = false;
  error = false;
  errorMessage = '';
  dontAskAgainChecked = true;
  resendCodeDisabled = true;
  privacyPolicyUrl = PRIVACY_POLICY_URL;

  constructor(private auth: AuthenticationService,
              private utilsService: UtilsService,
              private authService: AuthenticationService,
              private userService: CustomUserService) {
  }

  ngOnInit() {
    this.mfaMethod = environment.mfaMethod;
    this.enableResendLinkAfterTimeout();
  }

  onSubmit(code) {
    if (code.length === 6) {
      this.userService.confirmAuthCode(code, this.dontAskAgainChecked).subscribe({
          next: res => {
            this.submitted = false;
            const token = res['mfa-token-' + this.authService.getUserCurrent().uniqid + environment.subCookiesDomain];
            if (token) {
              const mfaCookieName = 'mfa-token-' + this.auth.getUserCurrent().uniqid;
              const oldTokens = this.utilsService.getCookie(mfaCookieName);
              const expireDate = new Date();
              expireDate.setMonth(expireDate.getMonth() + 1);
              if (oldTokens) {
                this.utilsService.saveCookie(mfaCookieName, oldTokens + '#' + token, expireDate);
                if (!this.utilsService.getCookie(mfaCookieName).includes(token)) {
                  this.utilsService.saveCookie(mfaCookieName, oldTokens + '#' + token, expireDate);
                }
              } else {
                this.utilsService.saveCookie(mfaCookieName, token, expireDate);
                if (!this.utilsService.getCookie(mfaCookieName)) {
                  this.utilsService.saveCookie(mfaCookieName, token, expireDate);
                }
              }
            }
            this.error = false;
            this.auth.userCurrent.permissions.incompleteLogin = false;
            this.auth.userAuthenticated.permissions.incompleteLogin = false;
            this.utilsService.lockUi();
            this.utilsService.deleteCookie('mfa');
            const redirectUrl = this.authService.redirectUrl;
            if (redirectUrl) {
              location.assign('/#' + redirectUrl);
            }
            // we should remove the old token before reload to avoid unwanted behaviour on the authGuard
            this.utilsService.deleteCookie('token');
            // removing from local storage the token key as saved
            localStorage.removeItem('token' + environment.subCookiesDomain);
            window.location.reload();
          }, error: error => {
            this.errorOnConfirmMfa(error);
          }
        }
      );
    }
  }

  private errorOnConfirmMfa(error) {
    this.submitted = false;
    if (error.status === 408) {
      this.error = true;
      this.errorMessage = 'The code you entered was expired. Please request a new code.';
    }
    if (error.status === 400) {
      this.error = true;
      this.errorMessage = 'The code you entered is not correct.';
    }
    if (error.status === 429) {
      this.cancel();
    }
    this.focusCodeInput(5);
  }

  cancel() {
    this.utilsService.deleteCookie('mfa');
    this.auth.logoutUser();
  }

  resendCode() {
    this.userService.resendMfaCode().subscribe(
      () => {
        this.error = false;
        this.codeResent = true;
        this.resendCodeDisabled = true;
        this.enableResendLinkAfterTimeout();
      }
    );
  }

  enableResendLinkAfterTimeout() {
    setTimeout(() => {
      this.resendCodeDisabled = false;
    }, 1000);
  }

  focusCodeInput(index: number) {
    setTimeout(() => {
      const firstInput = this.codeInput?.inputs?.[index];
      if (firstInput) {
        (firstInput as HTMLInputElement).focus();
      }
    });
  }

}
